import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { finalists } from "@/mocks/finalists";

const categoryMeta: Record<string, { icon: string; desc: string }> = {
  scene: { icon: "ri-movie-2-line", desc: "那些一眼难忘的高光瞬间" },
  reversal: { icon: "ri-loop-left-line", desc: "剧情突然调头的名场面" },
  backstage: { icon: "ri-clapperboard-line", desc: "镜头之外的细节与花絮" },
  comment: { icon: "ri-chat-quote-line", desc: "一句话改写走向的评论" },
  funny: { icon: "ri-emotion-laugh-line", desc: "看完忍不住笑出声的片段" },
  heart: { icon: "ri-heart-3-line", desc: "让人心里一动的温柔时刻" },
};

export default function CategorySection() {
  const grouped = Object.keys(categoryMeta).map((id) => {
    const item = finalists.find((f) => f.category === id);
    const count = finalists.filter((f) => f.category === id).length;
    return {
      id,
      name: item ? item.categoryName : id,
      count,
      ...categoryMeta[id],
    };
  });

  return (
    <section id="category" className="bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="mx-auto max-w-6xl">
          <SectionHeading
            eyebrow="主题分类"
            title="按分类浏览入围作品"
            desc="不同分类独立评比，各有所长。挑一个你感兴趣的方向开始浏览。"
            align="center"
          />

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {grouped.map((cat) => (
              <Link
                key={cat.id}
                to="/finalists"
                className="group rounded-lg border border-background-200 bg-background-50 p-6 hover:border-primary-400 transition-colors cursor-pointer flex items-start gap-4"
              >
                <span className="shrink-0 w-12 h-12 rounded-md bg-secondary-100 text-secondary-700 flex items-center justify-center text-2xl group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={cat.icon} />
                </span>
                <div className="min-w-0">
                  <h3 className="font-heading text-lg tracking-wide text-foreground-950 flex items-center gap-2">
                    {cat.name}
                    <span className="text-xs font-sans font-normal text-foreground-500">{cat.count} 件入围</span>
                  </h3>
                  <p className="mt-1 text-sm text-foreground-600">{cat.desc}</p>
                  <span className="mt-3 inline-flex items-center gap-1 text-xs font-medium text-primary-600">
                    进入分类
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}